import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

const STORAGE_KEY = 'consultsre_cookie_consent';

const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'dismissed');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Cookie notice"
      style={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9000,
        width: 'calc(100% - 48px)',
        maxWidth: 680,
        background: 'var(--bg-elev)',
        border: '1px solid var(--line-strong)',
        borderRadius: 'var(--r)',
        padding: '14px 18px',
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        boxShadow: '0 4px 24px rgba(0,0,0,0.18)',
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <p
          style={{
            margin: 0,
            fontFamily: 'var(--font-body)',
            fontSize: 13,
            color: 'var(--ink-dim)',
            lineHeight: 1.55,
          }}
        >
          This site uses essential cookies for security and session management only — no tracking or analytics.{' '}
          <Link
            to="/privacy-policy"
            style={{ color: 'var(--accent)', textDecoration: 'none' }}
          >
            Privacy Policy
          </Link>
        </p>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
        <button
          onClick={accept}
          style={{
            padding: '6px 14px',
            fontSize: 12,
            fontFamily: 'var(--font-mono)',
            fontWeight: 500,
            color: 'var(--bg)',
            background: 'var(--ink)',
            border: 'none',
            borderRadius: 'var(--r-sm)',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
        >
          Got it
        </button>
        <button
          onClick={dismiss}
          aria-label="Dismiss cookie notice"
          style={{
            display: 'inline-grid',
            placeItems: 'center',
            width: 28,
            height: 28,
            padding: 0,
            background: 'transparent',
            border: '1px solid var(--line)',
            borderRadius: 'var(--r-sm)',
            color: 'var(--ink-mute)',
            cursor: 'pointer',
          }}
        >
          <X size={13} />
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
